// extracted by mini-css-extract-plugin
export default {"root":"DimmerLoader_root__wOdlF","loading":"DimmerLoader_loading__wPSSr","loader":"DimmerLoader_loader__TbCsJ"};